import { useUnistyles } from "react-native-unistyles";
import { View, FormInput } from "@src/components";
import type { SortSelection } from "@src/features/clips/types/camera";
import { SortDropdown } from "./SortDropdown.web";
import { Icon } from "../Icon";

interface SearchAndSortBarProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  sortBy: SortSelection;
  onSortChange: (sortBy: SortSelection) => void;
}

export function SearchAndSortBar({ searchQuery, onSearchChange, sortBy, onSortChange }: SearchAndSortBarProps) {
  const { theme } = useUnistyles();

  return (
    <View flexDirection="row" alignItems="center" gap="md" style={{ maxWidth: 800 }}>
      {/* Search Input */}
      <View flex={1}>
        <FormInput
          placeholder="Search"
          value={searchQuery}
          onChangeText={onSearchChange}
          size="medium"
          iconLeft={<Icon name="search" size={theme.spacing["6xl"]} color={theme.colors.icon} />}
          containerStyle={{
            backgroundColor: theme.colors.surface,
            borderColor: theme.colors.borderCard,
          }}
        />
      </View>

      {/* Sort Dropdown */}
      <SortDropdown value={sortBy} onChange={onSortChange} />
    </View>
  );
}
